import { DB_AUTH_TOKEN, DB_KEY_USER_DATA, DB_SELECTED_BRAND_ID } from 'common/constants/db';
import { ILocalStorageType } from 'common/interfaces';
import { IUserProfile } from 'common/interfaces/iprofile';
import { IUser } from 'common/interfaces/iuser';
import {
  fetchLocalStorageData,
  fetchSessionStorageData,
  persistLocaleStorageData,
  persistSessionStorageData,
  removeLocalStorageData,
  removeSessionStorageData,
} from 'common/utils/db-utils';
import UILogger from 'common/utils/logger';
import { cloneDeep } from 'lodash';

export const persistsUserData = (user: IUser, type: ILocalStorageType) => {
  if (user) {
    const userClone = cloneDeep(user);
    if (type === 'localStorage') {
      removeSessionStorageData(DB_KEY_USER_DATA);
      persistLocaleStorageData(DB_KEY_USER_DATA, JSON.stringify(userClone));
    } else {
      removeLocalStorageData(DB_KEY_USER_DATA);
      persistSessionStorageData(DB_KEY_USER_DATA, JSON.stringify(userClone));
    }
  } else {
    if (type === 'localStorage') {
      removeSessionStorageData(DB_KEY_USER_DATA);
      persistLocaleStorageData(DB_KEY_USER_DATA, '{}');
    } else {
      removeLocalStorageData(DB_KEY_USER_DATA);
      persistSessionStorageData(DB_KEY_USER_DATA, '{}');
    }
  }
};

export const retrieveUserData = (): IUserProfile | null => {
  const data = fetchLocalStorageData(DB_KEY_USER_DATA);
  if (data) {
    return JSON.parse(data);
  }
  return null;
};

export const retrieveUserAuthToken = () => {
  let tkn = fetchSessionStorageData(DB_AUTH_TOKEN);
  if (!tkn) {
    tkn = fetchLocalStorageData(DB_AUTH_TOKEN);
  }
  UILogger.info('retrieveUserAuthToken:', tkn);
  return tkn || '';
};

export const persistUserAuthToken = (token: string, type: ILocalStorageType) => {
  UILogger.info('persistUserAuthToken:', token);
  if (type === 'localStorage') {
    removeSessionStorageData(DB_AUTH_TOKEN);
    persistLocaleStorageData(DB_AUTH_TOKEN, token);
  } else {
    removeLocalStorageData(DB_AUTH_TOKEN);
    persistSessionStorageData(DB_AUTH_TOKEN, token);
  }
};

export const retrieveSelectedBrandId = () => {
  let id = fetchSessionStorageData(DB_SELECTED_BRAND_ID);
  return id ? Number(id) : 0;
};

export const persistSelectedBrandId = (id: number) => {
  persistSessionStorageData(DB_SELECTED_BRAND_ID, (id || 0).toString());
};

export const clearLocalData = () => {
  UILogger.log('Cleaning local storage data...');
  removeLocalStorageData(DB_KEY_USER_DATA);
  removeLocalStorageData(DB_AUTH_TOKEN);
  removeSessionStorageData(DB_KEY_USER_DATA);
  removeSessionStorageData(DB_AUTH_TOKEN);
  removeSessionStorageData(DB_SELECTED_BRAND_ID);
};
